module.exports = __webpack_public_path__ + "img/Parts.e16236a8.jpg";